import { Injectable } from '@angular/core';
import { IAlertCustomConfig } from 'src/app/core/types/alert.interface';
import Swal, { SweetAlertIcon, SweetAlertOptions, SweetAlertResult } from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private getTitle(alertType: SweetAlertIcon, customTitle?: string): string {
    if(customTitle) { return customTitle }

    switch (alertType) {
      case 'success':
        return "Sucesso"
      case "error":
        return "Erro"
      case "info": 
        return "Info"
      case "warning":
        return "Aviso"
      case "question":
        return "Questão"
      default:
        return ""
    }
  }

  private generateSwalConfig(message: string, type: SweetAlertIcon, optionalData?: IAlertCustomConfig): SweetAlertOptions{
    const alertData: SweetAlertOptions = {
      ...optionalData,
      text: message,
      icon: type,
      title: this.getTitle(type, optionalData?.title as string)
    }
    return alertData
  }

  private showAlert(infoAlert: SweetAlertOptions): Promise<SweetAlertResult>{
    return Swal.fire(infoAlert)
  }

  error(message: string, optionalConfig?: IAlertCustomConfig): Promise<SweetAlertResult> {
    const alertData = this.generateSwalConfig(message, "error", optionalConfig)
    return this.showAlert(alertData)
  }

  success(message: string, optionalConfig?: IAlertCustomConfig): Promise<SweetAlertResult> {
    const alertData = this.generateSwalConfig(message, "success", optionalConfig)
    return this.showAlert(alertData)
  }

  info(message: string, optionalConfig?: IAlertCustomConfig): Promise<SweetAlertResult> {
    const alertData = this.generateSwalConfig(message, "info", optionalConfig)
    return this.showAlert(alertData)
  }

  warning(message: string, optionalConfig?: IAlertCustomConfig): Promise<SweetAlertResult> {
    const alertData = this.generateSwalConfig(message, "warning", optionalConfig)
    return this.showAlert(alertData)
  }

  question(message: string, optionalConfig?: IAlertCustomConfig): Promise<SweetAlertResult> {
    const alertData = this.generateSwalConfig(message, "question", optionalConfig)
    return this.showAlert(alertData)
  }

  show(config: SweetAlertOptions): Promise<SweetAlertResult> {
    return this.showAlert(config)
  }
}
